<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">“Orgies are so important, and they are things <br/>one knows<em class="italic"> nothing</em> about”<br/><span class="smallcaps">—</span>E<span class="smallcaps">. </span>M<span class="smallcaps">. </span>F<span class="smallcaps">ORSTER</span> to P. N. Furbank, 1953</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// arctic-summer_00001.vue?760a7404